import type { StaticImageData } from "next/image";
import overview from "@/assets/SystemImages/SystemDashboard.png";
import events from "@/assets/SystemImages/EventsMonitoring.png";
import faces from "@/assets/SystemImages/UsersFaceGereniment.png";
import devices from "@/assets/SystemImages/AIDevicesConect.png";
import school from "@/assets/SystemImages/GerenciamentoDeTurmasEAlunos.png";
import fleet from "@/assets/SystemImages/GeolocationOfSchoolTransportation.png";
import reports from "@/assets/SystemImages/GerarRelatórios.png";

/**
 * Telas reais do sistema (src/assets/SystemImages). Os textos descrevem apenas o que
 * aparece em cada imagem — nada de números ou recursos que a tela não mostre.
 */
export interface SystemScreen {
  id: string;
  image: StaticImageData;
  alt: string;
  /** rótulo curto (aba / barra da janela) */
  label: string;
  title: string;
  text: string;
  bullets?: string[];
}

/** Abas do destaque principal (janela grande com animação de scroll). */
export const showcaseScreens: SystemScreen[] = [
  {
    id: "overview",
    image: overview,
    alt: "Painel geral do Alert AI com dispositivos online, pessoas ativas, turmas, ocorrências críticas, central de ocorrências e saúde das sincronizações.",
    label: "Painel geral",
    title: "Painel geral",
    text: "Dispositivos online, pessoas cadastradas, turmas e ocorrências ativas, com a central de ocorrências, a saúde das sincronizações e o fluxo de eventos.",
  },
  {
    id: "events",
    image: events,
    alt: "Lista de eventos do Alert AI com filtros por tipo e período e o detalhe do evento selecionado.",
    label: "Eventos",
    title: "Eventos",
    text: "Todos os eventos em uma lista, com filtros por tipo (Facial, LPR, IVS, Aluno e Responsável) e por período, e o detalhe do evento selecionado ao lado.",
  },
  {
    id: "faces",
    image: faces,
    alt: "Tela de faces do Alert AI com busca, filtros e a tabela de pessoas cadastradas.",
    label: "Faces",
    title: "Faces",
    text: "Cadastro de faces com busca e filtros, cadastro rápido e ações para cada pessoa.",
  },
  {
    id: "devices",
    image: devices,
    alt: "Tela de câmeras do Alert AI com a lista de dispositivos, marca e tipo.",
    label: "Câmeras",
    title: "Câmeras e dispositivos",
    text: "Câmeras conectadas, de marcas como a Intelbras, com opções para gerenciar grupos e cadastrar uma nova câmera.",
  },
];

/** Etapas da narrativa com rolagem (texto à esquerda, janela fixa à direita). */
export const storyScreens: SystemScreen[] = [
  {
    id: "school",
    image: school,
    alt: "Visão geral da escola no Alert AI: turmas, frequência, atrasos, pais notificados e alunos em risco de evasão.",
    label: "Escola",
    title: "Visão geral da escola",
    text: "Monitoramento em tempo real de frequência, acessos e notificações, com as turmas ao lado.",
    bullets: [
      "Turmas com busca e visão de todas as turmas",
      "Frequência, atrasos e pais notificados",
      "Evolução dos últimos 30 dias e alunos em risco de evasão",
    ],
  },
  {
    id: "fleet",
    image: fleet,
    alt: "Mapa do Alert AI com a localização de um veículo, lista de veículos online e offline, placa, endereço e data e hora.",
    label: "Localização",
    title: "Veículos no mapa",
    text: "Acompanhe a localização dos veículos direto no mapa, com a lista ao lado.",
    bullets: [
      "Busca de veículos",
      "Filtros Online, Offline e Todos",
      "Placa, endereço e data e hora de cada veículo",
    ],
  },
  {
    id: "reports",
    image: reports,
    alt: "Central de relatórios do Alert AI com a lista de relatórios, grupos e o botão Gerar.",
    label: "Relatórios",
    title: "Central de relatórios",
    text: "Relatórios de alunos, eventos, dispositivos, reconhecimento e rostos, prontos para gerar.",
    bullets: [
      "Lista de relatórios com o grupo de cada um",
      "Filtro por grupo",
      "Geração com um clique",
    ],
  },
];
